import { Box, styled } from '@mui/material';

export const BoxOrderContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('xxl')]: {
    margin: '4px 0 0 0',
    width: 315,
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    margin: '4px 0 0 0',
    width: 255,
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    margin: '4px 0 0 -9px',
    width: 218,
  },
  [theme.breakpoints.down('sm')]: {
    margin: '4px 0 0 0',
    width: 312,
  },
}));

export const BoxOrderStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'inherit',
  marginLeft: 2,
}));
export const BoxChargesStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'inherit',
}));
